import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const customers_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
            filter:{
                status:[],
            },
            allFilters:[],
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_customers_request(state,loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_customers_success(state, payload){

            if(payload.loadData === 'new'){

                state.data.data = payload.customers.data;

            }else if(payload.loadData == 'more'){

                state.data.data.push(...payload.customers.data);

            }

            state.data.current_page = payload.customers.current_page;
            state.data.last_page = payload.customers.last_page;
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_customers_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;

        },
        add_customers_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_customers_list(state,payload){

            let customerIndex = state.data.data.findIndex((listedCustomer) => listedCustomer.id == payload.updatedCustomer.id);

            if(customerIndex != -1){

                state.data.data[customerIndex] = payload.updatedCustomer

            }

        },
        update_customer_status(state,payload){

            state.data.data[payload.index].isActive = payload.updatedCustomer.isActive;

        },
        delete_customers_list(state,payload){

            state.data.data.splice(payload,1);

        },
        customers_bulk_action(state,payload){

            if(payload.action == 'statusChange'){

                state.data.data = state.data.data.filter((customer)=>{

                    if(payload.listIds.includes(customer.id)){

                        customer.isActive = payload.status;

                        return customer;

                    }else{

                        return customer;

                    }

                });

            }

        },
        update_searched_keyword(state,payload){ 

            state.data.searchedKeyword = payload.keyword;

        },
        remove_searched_keyword(state){

            state.data.allFilters = []

            state.data.searchedKeyword = '';

        },
        update_customer_filters(state,payload){

            state.data.filter.status = payload.status

        },
        update_customer_all_filters(state,payload){

            state.data.allFilters = payload

        },
        remove_customer_filters(state){

            state.data.filter.status = []

        },
        CLEAR_MODULE(state){

            state.pending = false;
            state.loadingMore = false;
            state.message = null;
            state.success = null;
            state.error = null;

            state.data.current_page = 1;
            state.data.data = [];
            state.data.last_page = null;
            state.data.searchedKeyword= '';
            state.data.filter = {
                status:[],
            }
            state.data.allFilters = []

        }
    },
    actions:{
        async fetchStoreCustomersRequest({commit},{size, page, loadData}){
            
            commit('fetch_customers_request',loadData);

            const searchedKeyword = this.state.customers_module.data.searchedKeyword;
            let status = this.state.customers_module.data.filter.status[0];

            try{
                let res = await axios.get('/getCustomers',{
                    params:{
                        search: searchedKeyword.length > 0 ? searchedKeyword : null,
                        offset: size,
                        page: page,
                        active: status ? status == 'active' ? 1 : 0 : null,
                        with: 'city,cart,orders,last_purchase',
                    }
                });
                if(res.data.status_code == '1017'){

                    res.data.loadData = loadData;

                    commit('fetch_customers_success', res.data);

                }

            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_customers_failure', {error: ex, message: ex});
                
            }
            
        }
    },
    getters: {
        customers(state){

            return state.data.data;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}